/* eslint-disable vue/no-unused-components */
<template>
  <div>
    <!-- 登录-->
    <Modal
      v-model="githave"
      width="500px"
      class-name="vertical-center-modal"
      :mask-closable="false"
      @on-cancel="$emit('livets', false)"
    >
      <div style="min-height: 300px; padding: 40px 60px">
        <div class="zhuce flex_left">
          <p
            @click="loading('formItem', 0)"
            :class="indexLive == 0 ? 'actives' : ''"
          >
            短信登录
          </p>
          <p
            @click="loading('form_list', 1)"
            :class="indexLive == 1 ? 'actives' : ''"
          >
            密码登录
          </p>
        </div>

        <div v-if="indexLive == 0" key="12">
          <Form
            ref="form_list"
            :model="form_list"
            :rules="ruleInfo"
            :label-width="0"
          >
            <FormItem class="liItem" prop="phone">
              <img
                style="width: 22px; height: 25px"
                src="@/assets/images/inpone.png"
              />
              <Input
                height="50px"
                v-model="form_list.phone"
                placeholder="请输入您的手机号"
                @keyup.enter.native="keyupClick('code')"
              >
              </Input>
            </FormItem>
            <FormItem class="liItem top_input" prop="password">
              <img
                style="width: 23px; height: 25px"
                src="@/assets/images/dui.png"
              />
              <Input
                style="height: 50px"
                v-model="form_list.password"
                placeholder="请输入动态密码"
                ref="code"
                @keyup.enter.native="nextList('form_list')"
              ></Input
              ><Button
                v-show="codeList"
                @click="getCode('form_list')"
                style="
                  position: absolute;
                  top: 0px;
                  right: 0px;
                  width: 100px;
                  height: 45px;
                "
                >获取验证码</Button
              >
              <Button
                v-show="!codeList"
                style="
                  position: absolute;
                  top: 0px;
                  right: 0px;
                  width: 100px;
                  height: 45px;
                "
                >{{ times }}秒</Button
              >
              <div style="cursor: pointer; color: #1a33c5" @click="register()">
                注册
              </div>
            </FormItem>

            <FormItem>
              <Button
                style="width: 100%; height: 40px"
                @click="nextList('form_list')"
                type="primary"
                >登录</Button
              >
            </FormItem>
          </Form>
        </div>

        <div v-else-if="indexLive == 1" key="34">
          <Form
            ref="formItem"
            :model="formItem"
            :rules="formtimes"
            :label-width="0"
          >
            <FormItem class="liItem" prop="phones">
              <img
                style="width: 21px; height: 23px"
                src="@/assets/images/anto.png"
              />
              <Input
                height="50px"
                v-model="formItem.phones"
                placeholder="请输入您的手机号"
                @keyup.enter.native="keyupClick('mima')"
              >
              </Input>
            </FormItem>
            <FormItem class="liItem myPasswordInput" prop="passwords">
              <img
                style="width: 21px; height: 23px"
                src="@/assets/images/suo.png"
              />
              <Input
                style="height: 50px"
                v-model="formItem.passwords"
                type="password"
                placeholder="请输入密码"
                ref="mima"
                password
                @keyup.enter.native="nextList('formItem')"
              ></Input>
            </FormItem>
            <FormItem>
              <div
                style="float: left; cursor: pointer; color: #1a33c5"
                @click="register()"
              >
                注册
              </div>
              <div class="passwor" @click="forget()">忘记密码</div>
            </FormItem>
            <FormItem>
              <Button
                style="width: 100%; height: 40px"
                @click="nextList('formItem')"
                type="primary"
                ref="signIn"
                >登录</Button
              >
            </FormItem>
          </Form>
        </div>
      </div>
      <div slot="footer"></div>
      <VerifyCode
        ref="verifyCode"
        :show="show"
        :phone="form_list.phone"
        @success="handleVerifySuccess"
        @close="handleVerifyClose"
      ></VerifyCode>
    </Modal>
    <passwords
      :liveTop="liveTop"
      :comlist="comlist"
      @passwords="passWord"
    ></passwords>
    <register :topgit="topgit" @topgitnew="getRegister"></register>
  </div>
</template>
<script>
import {
  email,
  realName,
  select,
  upload,
  empty,
  phone,
  password,
  identity,
  verificationCode,
  pws,
  selectcity
} from '@/const/formValidate'
import DataApi from '@/api/login'
import passwords from './password.vue'
import register from './register.vue'
import VerifyCode from '@/views/home/components/VerifyCode.vue'
var vm
export default {
  props: ['dllogin'],
  name: '',
  data () {
    return {
      show: false,
      path: '',
      form_list: {
        phone: '',
        password: ''
      },
      topgit: false, // 注册
      comlist: 0,
      formItem: {
        phones: '',
        passwords: ''
      },
      ruleInfo: {
        phone: phone('你的手机号'),
        verifyStatus: [
          {
            validator: () => this.$refs.verifyRef.status,
            message: '请拖动滑块进行验证',
            trigger: 'blur'
          }
        ]
        // , password: verificationCode("你的验证码")
      },
      formtimes: {
        phones: phone('你的手机号'),
        passwords: empty('你的密码'),
        verifyStatus: [
          {
            validator: () => this.$refs.verifyRef1.status,
            message: '请拖动滑块进行验证',
            trigger: 'blur'
          }
        ]
      },
      indexLive: 0,
      liveTop: false,
      githave: this.dllogin,
      times: '', // 验证码获取时间
      codeList: true,
      count: null
    }
  },
  components: {
    passwords: passwords,
    register: register,
    VerifyCode
  },
  watch: {
    dllogin (value) {
      this.dllogin = value
      this.githave = value
    },
    githave (value) {
      this.githave = value
    },
    liveTop (value) {
      this.liveTop = value
    },
    cancel: {
      header (value) {
        // vm.githave = false;
        vm.$emit('livets', vm.githave)
      }
      // this.$refs[name].resetFields();
    }
  },
  created () {
    vm = this
  },
  mounted () {
    this.$root.Bus.$on('analy', function (msg, path) {
      vm.dllogin = msg
      vm.githave = msg
      vm.path = path
    })
  },

  methods: {
    getRegister (data) {
      vm.topgit = data
      this.dllogin = false
      vm.$emit('livets', vm.dllogin)
    },
    loading (name, index) {
      vm.indexLive = index
      this.$refs[name].resetFields()
    },
    keyupClick (name) {
      this.$nextTick(() => {
        vm.$refs[name].focus()
      })
    },
    forget () {
      vm.liveTop = true
      vm.githave = false
      vm.$emit('livets', vm.githave)
    },
    cancel (name) {
      vm.githave = false
      vm.$emit('livets', vm.githave)
    },
    passWord (index) {
      vm.liveTop = index
      vm.comlist = 0
      vm.dllogin = true
      vm.githave = true
    },
    getCode (name) {
      var inputs = /^1[3456789]\d{9}$/

      if (!vm.form_list.phone) {
        return this.$Message.error('请先输入手机号!')
      }

      if (!inputs.test(vm.form_list.phone)) {
        return this.$Message.error('请输入正确的手机号!')
      }

      // 校验手机号是否注册
      DataApi.accountIsExist({
        account: vm.form_list.phone
      }).then(res => {
        if (res.data) {
          return this.$Message.error('该手机号未被注册')
        }
        this.show = true
      })
    },
    handleVerifyClose () {
      this.show = false
    },
    handleVerifySuccess () {
      this.show = false
      if (this.times) return
      this.yanzheng()
    },
    yanzheng () {
      var data = {
        phone: vm.form_list.phone,
        adapter: 'login'
      }
      DataApi.regiteList(data)
        .then(res => {
          if (res.messageType == 'Success') {
            this.$Message.success('发送成功！')
            const TIME_COUNT = 60
            this.times = TIME_COUNT
            this.codeList = false
            this.times = 60
            var count = setInterval(() => {
              this.times--
              if (this.times <= 0) {
                this.codeList = true
                clearInterval(count)
              }
            }, 1000)
          } else {
            this.$Message.destroy()
            this.$Message.error(res.resultDesc)
          }
        })
        .catch(err => {
          console.log(err, 'errerrerrerr')
        })
    },
    register () {
      this.$nextTick(function () {
        // vm.$root.Bus.$emit('text', true)
        vm.topgit = true
      })
    },

    nextList (name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          var data = {}
          if (vm.indexLive == 0) {
            data = {
              username: vm.form_list.phone,
              validateCode: vm.form_list.password
            }
          } else if (vm.indexLive == 1) {
            data = {
              password: vm.formItem.passwords,
              username: vm.formItem.phones
            }
          }
          vm.logding(data)
        }
      })
    },
    logding (data) {
      if (data.validateCode == '' || data.password == '') {
        this.$Message.destroy()
        this.$Message.error('密码或验证码必须填写')
      } else {
        DataApi.loginList(data)
          .then(res => {
            if (res.messageType == 'Success') {
              // vm.githave = false;
              // vm.$emit("livets", vm.githave);
              var token = res.data.token
              window.sessionStorage.setItem('token', token)
              this.$Message.success('登录成功！')
              // this.$Message.success(res.resultDesc);
              setTimeout(() => {
                if (vm.path) {
                  window.location.href = vm.path
                } else {
                  this.$router.go(0)
                }
              }, 1000)
            } else {
              this.$Message.destroy()
              this.$Message.error(res.resultDesc)
            }
          })
          .catch(err => {})
      }
    }
  }
}
</script>
<style scoped="scoped" lang="less">
.flex_left {
  display: flex;
  justify-content: space-between;
}

/deep/.vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;
  .ivu-modal {
    top: 0;
  }
}
//
/deep/ .ivu-input {
  height: 45px;
  padding-left: 55px;
}
.zhuce {
  padding-top: 0px;
  padding-bottom: 30px;
  width: 50%;
  margin: 0 auto;
}
.zhuce p {
  text-align: center;
  font-size: 18px;
  font-family: Microsoft YaHei;
  cursor: pointer;

  line-height: 24px;
}
.actives {
  font-weight: bold;
  color: #2150cb;
}
.liItem {
  position: relative;
}
.liItem img {
  display: block;
  position: absolute;
  top: 10px;
  left: 15px;
  z-index: 999999;
}
.top_input /deep/ .ivu-input {
  width: 240px;
}
/deep/.ivu-modal-footer {
  display: none;
}
.passwor {
  text-align: right;
  cursor: pointer;
}

.myPasswordInput /deep/ .ivu-icon {
  font-size: 22px;
  line-height: 42px;
}
</style>
